export default "__VITE_ASSET__BcwamMD6__"